module.exports = __webpack_public_path__ + "py.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/py.svg
// module id = 1029
// module chunks = 0